
<div class="col-xs-12 pl-0 mt-4" *ngIf="editLogs.length">
  <div class="col-xs-12 list-header pl-0 bg-color py-1">Order Edit Logs</div>
  <div class="col-xs-12">
    <label class="col-xs-3 mt-1">Product</label>
    <label class="col-xs-3 mt-1">Action</label>
    <label class="col-xs-3 mt-1">Edited By</label>
    <label class="col-xs-3 mt-1">Date</label>
  </div>
  <div class="col-xs-12 py-1 fontS2" *ngFor="let log of editLogs">
    <div class="col-xs-3">{{log.metadata?.productId || '-'}}</div>
    <div class="col-xs-3">
      <span class="label" [ngClass]="{'label-success': log.action === 'added', 'label-danger': log.action === 'removed', 'label-info': log.action === 'updated'}">
        {{log.action}}
      </span>
    </div>
    <div class="col-xs-3">{{editedByName || '-'}}</div>
    <div class="col-xs-3">{{log.createdAt | amDateFormat: 'MMM DD YYYY, hh:mm a'}}</div>
  </div>
</div>
